module.exports = __webpack_public_path__ + "static/media/Sec-1_HomePageWeb_EN.97445b48.webp";